import { gql } from "@apollo/client";

export const ROTATE_CAMPAIGN_JOIN_TOKEN = gql`
  mutation campaignRotateJoinToken($campaignId: ID!) {
    campaignRotateJoinToken(id: $campaignId) {
      id
      token
      status
    }
  }
`;
